import {
  limitedReleaseByPhysicalConstants,
  createLimitedReleaseByPhysicalConstants,
  editLimitedReleaseByPhysicalConstants,
  activateLimitedReleaseByPhysicalConstants,
  deactivateLimitedReleaseByPhysicalConstants,
  deleteLimitedReleaseByPhysicalConstants,
} from "../_redux-constants";

export function limitedReleasesPhysicalReducer(
  state = {
    limitedReleaseByPhysicalLoading: false,
    limitedReleaseByPhysicalData: null,
    limitedReleaseByPhysicalError: null,

    createLimitedReleaseByPhysicalLoading: false,
    createLimitedReleaseByPhysicalData: null,
    createLimitedReleaseByPhysicalError: null,

    editLimitedReleaseByPhysicalLoading: false,
    editLimitedReleaseByPhysicalData: null,
    editLimitedReleaseByPhysicalError: null,

    addTargetLimitedReleaseByPhysicalLoading: false,
    addTargetLimitedReleaseByPhysicalData: null,
    addTargetLimitedReleaseByPhysicalError: null,

    removeTargetLimitedReleaseByPhysicalLoading: false,
    removeTargetLimitedReleaseByPhysicalData: null,
    removeTargetLimitedReleaseByPhysicalError: null,

    activateLimitedReleaseByPhysicalLoading: false,
    activateLimitedReleaseByPhysicalData: null,
    activateLimitedReleaseByPhysicalError: null,

    deactivateLimitedReleaseByPhysicalLoading: false,
    deactivateLimitedReleaseByPhysicalData: null,
    deactivateLimitedReleaseByPhysicalError: null,

    deleteLimitedReleaseByPhysicalLoading: false,
    deleteLimitedReleaseByPhysicalData: null,
    deleteLimitedReleaseByPhysicalError: null,
  },
  action
) {
  switch (action.type) {
    case limitedReleaseByPhysicalConstants.LIMITED_RELEASE_BY_PHYSICAL_LOADING:
      return Object.assign({}, state, {
        limitedReleaseByPhysicalLoading: true,
        limitedReleaseByPhysicalData: null,
        limitedReleaseByPhysicalError: null,
      });
    case limitedReleaseByPhysicalConstants.LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
      return Object.assign({}, state, {
        limitedReleaseByPhysicalLoading: false,
        limitedReleaseByPhysicalData: action.data,
      });
    case limitedReleaseByPhysicalConstants.LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
      return Object.assign({}, state, {
        limitedReleaseByPhysicalLoading: false,
        limitedReleaseByPhysicalData: null,
        limitedReleaseByPhysicalError: action.error,
      });
    case createLimitedReleaseByPhysicalConstants.CREATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING:
      return Object.assign({}, state, {
        createLimitedReleaseByPhysicalLoading: true,
        createLimitedReleaseByPhysicalData: null,
        createLimitedReleaseByPhysicalError: null,
      });
    case createLimitedReleaseByPhysicalConstants.CREATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
      return Object.assign({}, state, {
        createLimitedReleaseByPhysicalLoading: false,
        createLimitedReleaseByPhysicalData: action.data,
      });
    case createLimitedReleaseByPhysicalConstants.CREATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
      return Object.assign({}, state, {
        createLimitedReleaseByPhysicalLoading: false,
        createLimitedReleaseByPhysicalData: null,
        createLimitedReleaseByPhysicalError: action.error,
      });
    case editLimitedReleaseByPhysicalConstants.EDIT_LIMITED_RELEASE_BY_PHYSICAL_LOADING:
      return Object.assign({}, state, {
        editLimitedReleaseByPhysicalLoading: true,
        editLimitedReleaseByPhysicalData: null,
        editLimitedReleaseByPhysicalError: null,
      });
    case editLimitedReleaseByPhysicalConstants.EDIT_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
      return Object.assign({}, state, {
        editLimitedReleaseByPhysicalLoading: false,
        editLimitedReleaseByPhysicalData: action.data,
      });
    case editLimitedReleaseByPhysicalConstants.EDIT_LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
      return Object.assign({}, state, {
        editLimitedReleaseByPhysicalLoading: false,
        editLimitedReleaseByPhysicalData: null,
        editLimitedReleaseByPhysicalError: action.error,
      });
    case activateLimitedReleaseByPhysicalConstants.ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING:
      return Object.assign({}, state, {
        activateLimitedReleaseByPhysicalLoading: true,
        activateLimitedReleaseByPhysicalData: null,
        activateLimitedReleaseByPhysicalError: null,
      });
    case activateLimitedReleaseByPhysicalConstants.ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
      return Object.assign({}, state, {
        activateLimitedReleaseByPhysicalLoading: false,
        activateLimitedReleaseByPhysicalData: action.data,
      });
    case activateLimitedReleaseByPhysicalConstants.ACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
      return Object.assign({}, state, {
        activateLimitedReleaseByPhysicalLoading: false,
        activateLimitedReleaseByPhysicalData: null,
        activateLimitedReleaseByPhysicalError: action.error,
      });
    case deactivateLimitedReleaseByPhysicalConstants.DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_LOADING:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByPhysicalLoading: true,
        deactivateLimitedReleaseByPhysicalData: null,
        deactivateLimitedReleaseByPhysicalError: null,
      });
    case deactivateLimitedReleaseByPhysicalConstants.DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByPhysicalLoading: false,
        deactivateLimitedReleaseByPhysicalData: action.data,
      });
    case deactivateLimitedReleaseByPhysicalConstants.DEACTIVATE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
      return Object.assign({}, state, {
        deactivateLimitedReleaseByPhysicalLoading: false,
        deactivateLimitedReleaseByPhysicalData: null,
        deactivateLimitedReleaseByPhysicalError: action.error,
      });
    case deleteLimitedReleaseByPhysicalConstants.DELETE_LIMITED_RELEASE_BY_PHYSICAL_LOADING:
      return Object.assign({}, state, {
        deleteLimitedReleaseByPhysicalLoading: true,
        deleteLimitedReleaseByPhysicalData: null,
        deleteLimitedReleaseByPhysicalError: null,
      });
    case deleteLimitedReleaseByPhysicalConstants.DELETE_LIMITED_RELEASE_BY_PHYSICAL_SUCCESS:
      return Object.assign({}, state, {
        deleteLimitedReleaseByPhysicalLoading: false,
        deleteLimitedReleaseByPhysicalData: action.data,
      });
    case deleteLimitedReleaseByPhysicalConstants.DELETE_LIMITED_RELEASE_BY_PHYSICAL_FAILURE:
      return Object.assign({}, state, {
        deleteLimitedReleaseByPhysicalLoading: false,
        deleteLimitedReleaseByPhysicalData: null,
        deleteLimitedReleaseByPhysicalError: action.error,
      });
    default:
      return state;
  }
}
